import { moveToFulfilled } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { LeadershipTopConversationThemesLoadAction } from '../../domains/leadershipTopConversationThemes/actions.types';

import { LeadershipTopConversations } from './types';
export const initialState: LeadershipTopConversations = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<LeadershipTopConversations, LeadershipTopConversationThemesLoadAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'LEADERSHIP_TOP_CONVERSATION_THEMES.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.leadershipTopConversations);
    default:
      return state;
  }
};

export default reducer;
